import apiClient from './apiClient';

interface LoginResponse {
  user: {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    role: 'admin' | 'operator' | 'viewer';
  };
  accessToken: string;
  refreshToken: string;
}

interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

class AuthService {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await apiClient.post('/auth/login', {
      username: email,
      password,
    });
    // Backend returns { success, data: { user, token, refresh_token } }
    const { user, token, refresh_token } = response.data.data || response.data;
    return {
      user,
      accessToken: token,
      refreshToken: refresh_token,
    };
  }

  async logout(): Promise<void> {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      // Ignore logout errors
    }
  }

  async refreshToken(refreshToken: string): Promise<RefreshTokenResponse> {
    const response = await apiClient.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    // Backend returns { success, data: { token } }
    const data = response.data.data || response.data;
    return {
      accessToken: data.token,
      refreshToken: refreshToken, // Backend doesn't rotate refresh tokens
    };
  }

  async forgotPassword(email: string): Promise<void> {
    await apiClient.post('/auth/forgot-password', { email });
  }

  async resetPassword(token: string, password: string): Promise<void> {
    await apiClient.post('/auth/reset-password', { token, password });
  }

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await apiClient.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  }
}

export const authService = new AuthService();
